import React, { useContext } from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import api from "../../../services/api";
import NotificationAlert from "react-notification-alert";
import { MenuComportamento } from '../../../components/Menus'
import classnames from "classnames";

// reactstrap components
import {
    Button,
    ButtonGroup,
    Badge,
    Card,
    CardBody,
    CardHeader,
    Container,
    Row,
    Col,
} from "reactstrap";
// core components
import SimpleHeader from '../../../components/Headers/SimpleHeader'

const pagination = paginationFactory({
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    paginationTotalRenderer: (from, to, size) => {
        const margin = {
            paddingLeft: '4px'
        }
        return (
            <span className="react-bootstrap-table-pagination-total" style={margin}>
                Exibindo {from} de {to} do total de {size}.
            </span>
        )
    },
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
        <div className="dataTables_length" id="datatable-basic_length">
            <label>
                Exibir{" "}
                {
                    <select
                        name="datatable-basic_length"
                        aria-controls="datatable-basic"
                        className="form-control form-control-sm"
                        onChange={e => onSizePerPageChange(e.target.value)}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                }{" "}
                itens.
      </label>
        </div>
    )
});

const { SearchBar } = Search;

class Campanhas extends React.Component {


    state = {
        edit: null,
        alert: null,
        campanhas: [],
        situacao: '',
        localStorageEmpresaAnterior: 0
    }

    notify = (type, msg) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
                    <span data-notify="message">
                        {msg}
                    </span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 7
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    onNewClicked = async (e) => {
        e.preventDefault();
        this.props.history.push('campanhas/new')
    }

    dataCriacaoFormatter(cell, row) {
        const dt = new Date(row.data_postagem)
        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <>
                {dt.toLocaleDateString('pt-br', options)}
            </>
        )
    }
    async loadCampanhas() {
        const json = localStorage.getItem('@playnee-empresa')
        const empresaSelecionada = JSON.parse(json)
        const { situacao } = this.state
        const url = new URLSearchParams()
        if (situacao) url.set('situacao', situacao)
        const res = await api.get(`/common/empresas/${empresaSelecionada?.id}/campanhas/?${url.toString()}`);
        this.setData(res.data)
    }

    onSituacaoChange = (situacao) => {
        this.setState({ situacao }, () => this.loadCampanhas())
    }

    setData(data) {
        this.setState({
            campanhas: data
        })
    }

    //Vai para a tela de edição
    goToEdit(id) {
        this.props.history.push(`/admin/campanhas/${new Number(id)}/edit`)
    }

    valorFormatter(cell, row) {
        console.log(row.preco)
        return (
            <>
                {Number(row.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </>
        )
    }

    situacaoFormatter(cell, row) {
        let situacao = row.situacao
        let color = 'secondary'
        switch (row.situacao) {
            case 'Ativo':
                situacao = 'Ativo'
                color = 'success'
                break;
            case 'Inatio':
                color = 'secondary'
                break;
            case 'Em analise':
                color = 'warning'
                break;
            case '':
                color = 'danger'
                break;
        }
        return (

            <>
                <Badge color={color} className="badge-lg" pill>
                    {situacao}
                </Badge>
            </>
        )
    }



    componentDidMount() {
        this.loadCampanhas();
    }

    dataFormatter(cell, row) {
        const dt = new Date(cell)
        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <>
                {dt.toLocaleDateString('pt-br', options)}
            </>
        )
    }

    acoesFormatter = (cell, row,) => {

        return (
            <MenuComportamento
                actions={[
                    {
                        label: 'Alterar',
                        icon: 'far fa-edit',
                        onClick: () => this.goToEdit(row.id)
                    }
                ]}
            />
        )
    }





    render() {
        const { campanhas, situacao } = this.state

        return (
            <>
                {this.state.alert}
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert" />
                </div>
                <SimpleHeader name="Listagem de campanhas" parentName="Campanhas" {...this.props} />
                <div className="w-100">
                    <Row>
                        <Col>
                            <Card>
                                <ToolkitProvider
                                    data={campanhas}
                                    keyField='id'
                                    columns={[
                                        {
                                            dataField: 'acoes',
                                            formatter: (cell, row) => this.acoesFormatter(cell, row,)
                                        },
                                        {
                                            dataField: "nome",
                                            text: 'Nome',
                                            sort: true,
                                        },
                                        {
                                            dataField: 'dt_inicio',
                                            text: 'Data de inicio',
                                            sort: true,
                                            formatter: this.dataFormatter
                                        },
                                        {
                                            dataField: 'dt_fim',
                                            text: 'Data final',
                                            sort: true,
                                            formatter: this.dataFormatter
                                        },
                                        {
                                            dataField: 'situacao',
                                            text: 'Situação',
                                            formatter: this.situacaoFormatter,
                                            sort: true
                                        }
                                    ]}
                                    search
                                >
                                    {props => (
                                        <>
                                            <CardHeader
                                                className="d-flex justify-content-between align-items-center"
                                                style={{
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1,
                                                }}>
                                                <h1 className="mb-0">Campanhas</h1>
                                                <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                    <ButtonGroup
                                                        className="btn-group-toggle"
                                                        size="sm"
                                                        data-toggle="buttons"
                                                    >
                                                        {[
                                                            { id: '', text: 'Todos' },
                                                            { id: 'ativo', text: 'Ativos' },
                                                            { id: 'inativo', text: 'Inativos' },
                                                        ].map((item, key) => (
                                                            <Button
                                                                key={key}
                                                                className={classnames({ active: situacao == item.id })}
                                                                color="secondary"
                                                                onClick={() => this.onSituacaoChange(item.id)}
                                                            >
                                                                {item.text}
                                                            </Button>
                                                        ))}
                                                    </ButtonGroup>
                                                    <SearchBar
                                                        className="form-control-sm"
                                                        placeholder="Pesquisar..."
                                                        {...props.searchProps}
                                                    />
                                                    <Button
                                                        id="tooltip0983764373524743"
                                                        color="primary"
                                                        type="button"
                                                        onClick={e => this.onNewClicked(e)}
                                                        size="sm">
                                                        <span className="btn-inner--icon">
                                                            <i className="ni ni-fat-add" />
                                                        </span>
                                                        Nova Campanha
                                                    </Button>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <div className="table-responsive">
                                                    <BootstrapTable
                                                        {...props.baseProps}
                                                        bootstrap4={true}
                                                        pagination={pagination}
                                                        bordered={false}
                                                        classes="table-sm table-v-middle"
                                                        condensed
                                                    />
                                                </div>
                                            </CardBody>
                                        </>
                                    )}
                                </ToolkitProvider>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }


}

export default Campanhas;